import script from "./checkinRewards.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkinRewards.vue?vue&type=script&setup=true&lang=ts"

import "./checkinRewards.vue?vue&type=style&index=0&id=1ca99015&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca99015"]])

export default __exports__